<div class="flex flex-col gap-2">
  <div class="flex items-center justify-between">
    <span class="text-sm font-semibold text-gray-11">{{ title() }}</span>
    <button mat-button (click)="add.emit()">
      <mat-icon>add</mat-icon>
      {{ addButtonLabel() }}
    </button>
  </div>

  @for (item of controls; track $index) {
    <div
      [formGroup]="item"
      class="group relative flex flex-col gap-2 rounded-lg border border-gray-6 bg-gray-1 p-3 transition-colors hover:border-gray-7"
    >
      <div class="flex items-center gap-2">
        <span class="text-xs font-bold text-gray-9 uppercase">{{ itemLabel() }} #{{ $index + 1 }}</span>
        <div class="flex-1"></div>
        <button
          mat-icon-button
          (click)="remove.emit($index)"
          class="opacity-0 transition-opacity group-hover:opacity-100 text-ruby-11 hover:bg-ruby-a3"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>

      <div class="flex items-start gap-3">
        <!-- Optional Type Select -->
        @if (typeOptions()) {
          <mat-form-field appearance="outline" class="flex-1" subscriptSizing="dynamic">
            <mat-label>Type de {{ itemLabel() | lowercase }} *</mat-label>
            <mat-select formControlName="type" required>
              @for (type of typeOptions(); track type) {
                <mat-option [value]="type">{{ type | etxeEnumDisplay: typeEnumLabel() || '' }}</mat-option>
              }
            </mat-select>
            @if (item.controls.type?.invalid && item.controls.type?.touched) {
              <mat-error>Requis</mat-error>
            }
          </mat-form-field>
        }

        <!-- Surface Input -->
        <mat-form-field
          appearance="outline"
          [class]="typeOptions() ? 'w-28' : 'w-36'"
          subscriptSizing="dynamic"
        >
          <mat-label>Surface *</mat-label>
          <input matInput type="number" formControlName="surface" placeholder="0" min="0.1" required />
          <span matSuffix>m²</span>
          @if (item.controls.surface?.invalid && item.controls.surface?.touched) {
            <mat-error>Requis</mat-error>
          }
        </mat-form-field>

        <!-- Lot Number Input -->
        @if (showLotNumber()) {
          <mat-form-field appearance="outline" class="w-32" subscriptSizing="dynamic">
            <mat-label>N° de lot</mat-label>
            <input matInput formControlName="lotNumber" placeholder="Ex: 12" min="0" />
          </mat-form-field>
        }

        <!-- Precision Input (if no type options, it takes more space) -->
        @if (!typeOptions()) {
          <mat-form-field appearance="outline" class="flex-2" subscriptSizing="dynamic">
            <mat-label>Précision ou description</mat-label>
            <input matInput formControlName="precision" [placeholder]="descriptionPlaceholder()" />
          </mat-form-field>
        }
      </div>

      <!-- Precision Input (if type options exist, it goes to next line) -->
      @if (typeOptions()) {
        <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
          <mat-label>Précision ou description</mat-label>
          <input matInput formControlName="precision" [placeholder]="descriptionPlaceholder()" />
        </mat-form-field>
      }

      @if (hint()) {
        <mat-hint class="text-[10px] text-gray-9">{{ hint() }}</mat-hint>
      }
    </div>
  }
</div>
